<template>
  <span>
    <span @click="openModalAction" class="link"><i class="fal fa-envelope"></i> メールアドレスを変更</span>
    <ModalBackground v-if="isActive"/>
    <div v-if="isActive" class="modal-container" @click.self="closeModalAction">
      <div class="inner">
        <div class="close-button-container" @click="closeModalAction">
          <CloseButton/>
        </div>
        <FormHelper class="form-container" @callback="callback" :formSettings="formSettings"/>
      </div>
    </div>
    <div v-if="$isDebug() && debugVerifyToken" class="debug-option-container">
      <router-link :to="{name: 'ChangeEmail', params:{token: debugVerifyToken, session:debugSessionId}}" class="link">[DEBUG]メール認証</router-link>
    </div>
  </span>
</template>

<script>
import ModalBackground from '@/components/common/ModalBackground';
import FormHelper from '@/components/common/FormHelper';
import CloseButton from '@/components/user/CloseButton';

export default {
  components: {
    ModalBackground,
    FormHelper,
    CloseButton
  },
  data () {
    return {
      formSettings: { //フォームの設定を記載
        store: 'user',
        dispatch: 'changeEmail',
        header: 'メールアドレスを変更します',
        forms: {
          email: {
            label: '新しいメールアドレス',
            type: 'text',
            require: true,
            placeholder: 'mail@example.com',
            default: '',
            validate: [],
            option: {
              size: 300,
            }
          }
        },
        useSessionId: true,
        submit: {
          label: '変更',
          color: 'b'
        },
        info: [], // フォーム下部の補足説明
        reasonCode: {
          DUPLICATE_EMAIL_ENTRY: 'すでに登録済みのメールアドレスです'
        },
      },
      option: {
        is1Button: true,
        buttonLabel: '閉じる',
        callback: 'OK1',
        callbackO: 'close',
        messages: ['入力されたメールアドレスにメールを送信しました', 'メールの内容をご確認ください']
      },
      isActive: false,
      debugVerifyToken: null,
      debugSessionId: null
    };
  },
  methods: {
    openModalAction: function () {
      console.log('openDialog');
      this.isActive = true;

      scrollTo(0,0);
    },
    closeModalAction: function () {
      console.log('closeDialog');
      this.isActive = false;
    },
    callback: function (dispatcher, value) {
      console.log('callback', dispatcher, value);

      if(dispatcher === 'FormHelperNotice'){
        return;
      } else if(dispatcher === 'FormHelperFinish'){

        this.isActive = false;

        // 完了メッセージ
        this.$store.dispatch('message/open', this.option).then();

        if (!this.$isDebug()) {
          return;
        }

        // -- デバッグリンク

        let getter = this.formSettings.store + '/response';

        let response = this.$store.getters[getter];
        console.log(response.token);
        console.log(response.session);

        this.debugVerifyToken = response.token;
        this.debugSessionId = response.session;
      }

    }
  }
};

</script>

<style lang="scss" scoped>

  .link{
    font-size: 14px;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
  }

  // 801以上
  @media screen and (min-width: 801px) {

  }

  // 800まで
  @media screen and (max-width: 800px) {
  }

</style>
